import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { Footnote } from 'src/app/models/footnote.model'
import { Returns } from 'src/app/models/performance-response.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

@Component({
  selector: 'performance-summary',
  templateUrl: './performance-summary.component.html',
  styleUrls: ['./performance-summary.component.scss'],
  providers: [],
})
export class PerformanceSummaryComponent implements OnInit, OnDestroy {
  @ViewChild('simpleDialogBodyContent')
  simpleDialogBodyContent: TemplateRef<any>
  @ViewChild('importantVanguard529DialogBodyContent')
  importantVanguard529DialogBodyContent: TemplateRef<any>
  @ViewChild('dialogBodyContainer', { read: ViewContainerRef })
  dialogBodyContainer: ViewContainerRef

  @Input() data: Returns
  @Input() profileData: any
  @Input() benchmarkFootNote: Footnote
  @Input() performanceFootNote: Footnote
  @Input() marketPriceFootNote: Footnote

  //AEM content variables
  performanceInformation529: AEMChunk
  fairValuePricingInformation: AEMChunk
  mfEtf529sPerformanceTotalReturns: AEMChunk
  performanceTypicalMfInvestment529: AEMChunk
  performanceExpenseRatios529: AEMChunk
  performanceProspectusInformation529: AEMChunk
  aemContentSub: Subscription

  dataType = 'monthEndAvgAnnualRtn'
  subdataType = 'recentInvestmentRtn'
  segmentValue: string
  totalReturn: string
  dialogTitle: string
  dataMap = {
    monthEndAvgAnnualRtn: '3-Month total',
    quarterEndAvgAnnualRtn: 'Quarter-end',
  }

  constructor(
    public viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
    public adobeLaunchService: AdobeLaunchService,
  ) {}

  ngOnInit() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.fairValuePricingInformation =
      this.centralContentService.getContentByBody(
        'disclaimer_fair_value_pricing_information',
        content,
      )
    this.mfEtf529sPerformanceTotalReturns =
      this.centralContentService.getContentByBody(
        'fund_definitions_mf_etf_529s_performance_total_returns',
        content,
      )
    this.performanceTypicalMfInvestment529 =
      this.centralContentService.getContentByBody(
        'fund_definitions_529_performance_not_a_typical_mf_investment',
        content,
      )
    this.performanceExpenseRatios529 =
      this.centralContentService.getContentByBody(
        'fund_definitions_529_performance_expense_ratios',
        content,
      )
    this.performanceProspectusInformation529 =
      this.centralContentService.getContentByBody(
        'fund_definitions_529_performance_prospectus_information',
        content,
      )
  }

  onValueChange(event: any) {
    if (event === 'monthEnd') {
      this.dataType = 'monthEndAvgAnnualRtn'
      this.subdataType = 'recentInvestmentRtn'
      this.segmentValue = 'month-end'
      document
        .getElementById('Month-End')
        ?.classList.add('c11n-segmented-control__segment--active')
      document
        .getElementById('Quarterly-Pre-Tax')
        ?.classList.remove('c11n-segmented-control__segment--active')
    } else {
      this.dataType = 'quarterEndAvgAnnualRtn'
      this.subdataType = 'quarterEndAvgAnnualRtn'
      this.segmentValue = 'Quarterly (Pre-tax)'
      document
        .getElementById('Quarterly-Pre-Tax')
        ?.classList.add('c11n-segmented-control__segment--active')
      document
        .getElementById('Month-End')
        ?.classList.remove('c11n-segmented-control__segment--active')
    }
    if (this.totalReturn !== undefined) {
      this.addTag()
    }
    this.totalReturn = this.dataType
  }
  addTag() {
    if (this.profileData?.isETF || this.profileData?.isMutualFund) {
      this.adobeLaunchService.subPageTabEvent(
        `${this.profileData?.ticker}:totalreturns:summary:toggle:${this.segmentValue}`,
      )
    } else if (this.profileData?.is529) {
      this.adobeLaunchService.subPageTabEvent(
        `${this.profileData?.fundId}:totalreturns:summary:toggle:${this.segmentValue}`,
      )
    }
  }
  formatData(data) {
    data = this.centralContentService.formatLink(data)
    return data
  }

  public setDialogInfo(title: string) {
    this.dialogTitle = title
    this.dialogBodyContainer.clear()
    if (title == 'Fair-value pricing information') {
      this.dialogBodyContainer.createEmbeddedView(this.simpleDialogBodyContent)
    } else if (
      title == 'Important performance information for Vanguard 529 portfolios'
    ) {
      this.dialogBodyContainer.createEmbeddedView(
        this.importantVanguard529DialogBodyContent,
      )
    }
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
